/**
 * イベントの開催期間の表示 (#1886)。
 *
 * これまでは日付だけで、**開始・終了の時刻が出ていなかった**。産業フェスのように
 * 「10/10 の 10:00〜15:30」という 1 日のイベントでは、時刻こそが知りたい情報で、
 * 「10月10日 – 10月10日」は何も言っていないのと同じになる。
 *
 * 同じ日なら日付は 1 回だけ出す:
 *   同日  … 10月10日 10:00 – 15:30
 *   複数日 … 9月9日 10:00 – 9月10日 17:00
 *
 * 時刻を持たない (両方 00:00 の) イベントは**日付だけ**に落とす。開催時間を決めずに
 * 作った古いイベントで「0:00 – 0:00」と出すと、閉まっているように読める。
 */
export function formatEventPeriod(
  startsAt: string,
  endsAt: string,
  locale: string,
  opts: { month?: 'short' | 'long' } = {},
): string {
  const start = new Date(startsAt)
  const end = new Date(endsAt)
  const month = opts.month ?? 'short'

  const date = (d: Date) => d.toLocaleDateString(locale, { month, day: 'numeric' })
  const time = (d: Date) =>
    d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit', hour12: false })

  const sameDay =
    start.getFullYear() === end.getFullYear() &&
    start.getMonth() === end.getMonth() &&
    start.getDate() === end.getDate()

  const midnight = (d: Date) => d.getHours() === 0 && d.getMinutes() === 0
  const hasTime = !(midnight(start) && midnight(end))

  if (!hasTime) return sameDay ? date(start) : `${date(start)} – ${date(end)}`
  if (sameDay) return `${date(start)} ${time(start)} – ${time(end)}`
  return `${date(start)} ${time(start)} – ${date(end)} ${time(end)}`
}
